/**
 * Banco de ítems JK-Core — Oficina administrativa (500 ítems).
 * moduleId: JK_OFFICE_ADMIN
 * Respuestas: VERDADERO / FALSO / NO SÉ
 */

import bankData from './jkOfficeAdminBank.json';

export interface JKOfficeAdminItem {
  id: string;
  correctAnswer: 'V' | 'F';
  text: string;
}

export const JK_OFFICE_ADMIN_ID = 'JK_OFFICE_ADMIN' as const;

export const JK_OFFICE_ADMIN_BANK: JKOfficeAdminItem[] = bankData as JKOfficeAdminItem[];

/** Selecciona n ítems aleatorios sin repetición. */
export function pickRandomJKOfficeAdminItems(count: number): JKOfficeAdminItem[] {
  const shuffled = [...JK_OFFICE_ADMIN_BANK].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count);
}
